export default {
  facilities: `profile/facilities`,
  update: `profile/facilities/update`,
  remove: `profile/facilities/remove`,
};
